var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5788 11.5789C11.3462 11.8115 10.9692 11.8115 10.7367 11.5789L4.4209 5.26319C4.18836 5.03065 4.18836 4.65363 4.4209 4.42109C4.65344 4.18855 5.03046 4.18855 5.263 4.42109L11.5788 10.7368C11.8113 10.9694 11.8113 11.3464 11.5788 11.5789Z",
    fill: "#070707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42154 11.5793C4.189 11.3467 4.189 10.9697 4.42154 10.7372L10.7373 4.42139C10.9698 4.18885 11.3469 4.18885 11.5794 4.42139C11.8119 4.65393 11.8119 5.03095 11.5794 5.26349L5.26364 11.5793C5.0311 11.8118 4.65408 11.8118 4.42154 11.5793Z",
    fill: "#070707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSm);
export default __webpack_public_path__ + "static/media/close_sm.d392031e8add778cee5b775bcd8544b8.svg";
export { ForwardRef as ReactComponent };